/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo } from "react";
import { Tabs, message, Spin } from "antd";
import CashQuotation from "./CashQuotation";
import AccountQuotation from "./AccountQuotation";
import API from "../../../api";
import urls from "../../../api/urls";
import { useLocation, useParams } from "react-router-dom";
import Heading from "../../Heading";

const { GET_RATE_CARD_QUOTATION } = urls;

const NewRateCard = () => {
  const history = useLocation();
  const [loader, setLoader] = useState(false);
  const [cashData, setCashData] = useState({});
  const [accountData, setAccountData] = useState({});
  const [activeKey, setActiveKey] = useState("1");
  const params = useParams();

  useEffect(() => {
    if (history?.state?.rateCards?.length > 0) {
      checkAndSetActiveKey();

      history?.state?.rateCards?.map((val) => {
        let showApprove =
          val?.status?.toUpperCase() === "PENDING" &&
          history?.state?.type === "ho-lead";
        getQuotationDetail(val, showApprove);
      });
    }
  }, [history?.state?.rateCards]);

  const checkAndSetActiveKey = () => {
    const hasCash = history?.state?.rateCards.some(
      (item) => item.rateCardType === "CASH"
    );
    const hasAccount = history?.state?.rateCards.some(
      (item) => item.rateCardType === "ACCOUNT"
    );

    if (hasCash) {
      setActiveKey("1"); // Prioritize "CASH"
    } else if (!hasCash && hasAccount) {
      setActiveKey("2"); // If no "CASH", check for "ACCOUNT"
    }
  };

  const changeTab = (key) => {
    setActiveKey(key);
  };

  const getQuotationDetail = async (val, showApprove) => {
    try {
      setLoader(true);
      const res = await API.Api(
        GET_RATE_CARD_QUOTATION +
          val?.rateCardName +
          "?includeOld=" +
          showApprove
      ).get();
      if (res?.status) {
        if (val?.rateCardType === "ACCOUNT") {
          setAccountData({ data: res.response?.data, isPending: showApprove });
        }

        if (val?.rateCardType === "CASH") {
          setCashData({ data: res.response?.data, isPending: showApprove });
        }
      }
    } catch (error) {
      message.error("Failed to fetch quotation details.");
    } finally {
      setLoader(false);
    }
  };

  const tabItems = useMemo(
    () => [
      cashData?.data && {
        label: "Cash Rate",
        key: "1",
        children: (
          <CashQuotation
            //tabChange={() => setActiveKey("2")}
            loader={loader}
            cashData={cashData}
            accountPresent={accountData?.data ? true : false}
            navigateId={history?.state?.navigateId}
            changeTab={(val) => changeTab(val)}
          />
        ),
      },
      accountData?.data && {
        label: "Account Rate",
        key: "2",
        children: (
          <AccountQuotation
            loader={loader}
            accountData={accountData}
            navigateId={history?.state?.navigateId}
          />
        ),
      },
    ],
    [loader, cashData, accountData]
  );

  return (
    <div className="p-1">
      <Spin spinning={loader}>
        <Heading title="Assigned Quotation" />
        {cashData?.data || accountData?.data ? (
          <Tabs
            type="card"
            items={tabItems}
            activeKey={activeKey}
            onChange={changeTab}
            className="rate-card-tab"
          />
        ) : (
          <div className="no-data-prresnt">No data available</div>
        )}
      </Spin>
    </div>
  );
};

export default NewRateCard;
